import { useEffect } from "react";

const baseVorinStylesheets = [
  "/static/site/venuex/vorin/css/vendors.min.css",
  "/static/site/venuex/vorin/css/icon.min.css",
  "/static/site/venuex/vorin/css/style.css",
  "/static/site/venuex/vorin/css/responsive.css",
  "/static/site/venuex/vorin/demos/web-agency/web-agency.css",
] as const;

type UseVorinAssetsOptions = {
  extraStylesheets?: readonly string[];
};

export function useVorinAssets(options?: UseVorinAssetsOptions) {
  const extraStylesheets = options?.extraStylesheets ?? [];
  const stylesheetKey = extraStylesheets.join("|");

  useEffect(() => {
    const appendedNodes: HTMLLinkElement[] = [];
    const previousHtmlOverflowX = document.documentElement.style.overflowX;
    const previousBodyOverflowX = document.body.style.overflowX;
    const stylesheets = [...baseVorinStylesheets, ...extraStylesheets];

    stylesheets.forEach((href) => {
      const existingNode = document.querySelector<HTMLLinkElement>(
        `link[data-vorin-href="${href}"]`,
      );

      if (existingNode) {
        return;
      }

      const node = document.createElement("link");
      node.rel = "stylesheet";
      node.href = href;
      node.dataset.vorinHref = href;
      document.head.appendChild(node);
      appendedNodes.push(node);
    });

    document.body.classList.add("vorin-page-active");
    document.documentElement.style.overflowX = "hidden";
    document.body.style.overflowX = "hidden";

    return () => {
      appendedNodes.forEach((node) => node.remove());
      document.body.classList.remove("vorin-page-active");
      document.documentElement.style.overflowX = previousHtmlOverflowX;
      document.body.style.overflowX = previousBodyOverflowX;
    };
  }, [stylesheetKey]);
}
